import { ApiClient } from './client.js'
import { PARTIAL_ACCOUNT_SETUPS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (partialId) {
    return client.get(`${PARTIAL_ACCOUNT_SETUPS}${partialId}/`)
  },

  activate (partialId, data) {
    return client.patch(`${PARTIAL_ACCOUNT_SETUPS}${partialId}/`, data)
  }
}
